import { FeatureFlagMap } from '../types/blp-feature-flags';
import { getPlatformApiHost } from '../utils/hosts';
import logger from '../utils/logger-rum';

export default function GetFeatureFlags(): Promise<FeatureFlagMap> {
	return fetch(`${getPlatformApiHost()}/v3/feature-flags`).then((res) => {
		if (res.ok) {
			if (res.headers.get('content-type')?.includes('application/json')) {
				return res.json();
			}
			throw new Error('Invalid content type');
		} else {
			throw new Error('Request failed');
		}
	}).catch((error) => {
		logger.error('Error fetching blp feature flags:', error);
		return {};
	});
}
